module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "chapter-no",
    attrs: {
      "id": "ch-5"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_vm._v("5")])]), _c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("B"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("RIDGET FINDS A SMALL FURNISHED FLAT")]), _vm._v(" not far from Arnold’s, but what was to have been a rental of several weeks stretches into several months, and Tibor finally takes a leave of absence from his job as a high school counselor to be with her. Their daughter Leora, back in Boston, is living with the family of a friend and she does not take her desertion gracefully. She is seventeen and a senior in high school. There are proms to plan for, social crises of one sort or another, colleges to think about.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“I want you to come home,” she says on the telephone. “I need you. There’s so much going on.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("As she speaks Leora can picture her mother’s face. When Leora broaches a subject that Bridget does not want to discuss, it is as if the words themselves have not been said, as if Leora has spoken in a foreign language.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Did you remember your dentist appointment,” her mother might reply or, “Uncle Danny says he took you to dinner last night.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Leora can almost see the face, the blank, uncomprehending face.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“You can’t just move somewhere else,” she repeats. “You live here.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("I keep an eye on my niece, speak to her each night, see her at least once during the week, but I begin to find her increasingly monosyllabic. (“I’m fine.” “School’s fine.” “Yes, she called.”) In a restaurant she looks into her plate, twirls her hair, can’t help but smile when I am particularly provocative.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_19"
    }
  }), _c('a', {
    attrs: {
      "id": "page_20"
    }
  }, [_vm._v("“What happened to that boy Mumbles who couldn’t take his eyes off you?”")])]), _c('a', {
    attrs: {
      "id": "page_20"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“His name is "), _c('em', [_vm._v("Barry")]), _vm._v(".”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“It should be Mumbles. I didn’t understand a word he said.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Still, she keeps to herself, particularly about what is most important in her adolescent life.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("I cannot drop everything and move to London as Bridget has done. I also wonder whether that would be a normal thing to do, for an adult, a man in his forties with a wife and more than his share of responsibilities, to put everything on hold and to move across the world to tend a dying parent. There are people who count on me, for one thing, people who have entrusted their money to me and who rely on my judgment in a variety of quickly changing markets. And there is my wife, Tesseba, tolerant but critical too, tolerant but evaluating at the same time.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("And yet, yet, backwards and forwards, the exhausting jet travel, a manic pace. I have decided that I cannot drop everything, but I have also decided that I cannot "), _c('em', [_vm._v("not")]), _vm._v(" drop everything. As my mother’s health worsens I find myself careening between Boston and London until it seems as if I am constantly in motion. At first Tesseba and Leora travel with me, and they quickly fall into habits like seasoned travelers. Leora does her homework at the window. Tesseba reads. I work on my laptop until I fall asleep with a black velvet mask over my eyes. And then, just as I think things have settled into a pattern that works well for everyone, they surprise me. Tesseba says that she finds it too exhausting, the time changes, the long flights, the seemingly pointless hanging about once we finally arrive, and decides to stay home. As for Leora, I had assumed this was something of an adventure for her—what teenage girl gets to fly, first class, to London every weekend?—but there I am mistaken too.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_20"
    }
  }, [_vm._v("Leora, who at first accepted without comment the arrangements I made for her—“The plane leaves Logan at seven, Lee. The limo will ")]), _c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_vm._v("pick you up at four thirty.”—now begins to find excuses not to accompany me.")])]), _c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“You don’t want to come?” I ask, surprised.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“I can’t just leave town all the time,” she says. “I have things I need to do here.”")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-25b47e7f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/012_Chapter05.vue
// module id = 96
// module chunks = 0